// extracted by mini-css-extract-plugin
export var root = "D_t0";
export var wrapper = "D_t1";
export var image = "D_t2 d_w d_y d_W";
export var imageWithHeight = "D_t3";
export var crop = "D_t4";
export var round = "D_t5";
export var fixedHeight = "D_t6";